import React, { Component } from 'react';
import MobileDetect from 'mobile-detect';
import NoQuotesLayout from '../components/NoQuotesLayout/NoQuotesLayout';
import DeepQuoteExploration from '../components/DeepQuoteExploration/DeepQuoteExploration';
import QuotesLayout from '../components/QuotesLayout';
import FixedButton from '../../../common/Buttons/components/FixedButton';
import axios from 'axios';
import { compose } from 'recompose';
import {withMobileDetect} from '../../../utils/hocs/mobileDetectHoc';
import { withRouter } from "react-router";
import {connect} from 'react-redux';
import {getQuotes, setLoading, updateProgressBar, updateApplicationState, updateApplicationTimestamp, getStates, saveSurveyResponse} from '../../../store/actions/consumerActions';
import Loader from '../../../common/Loader/components/loader';
import $ from 'jquery';
class Quotes extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.cancelToken = null;
    this.lastUpdateTimestamp = Date.now();
    this.surveyBreakpoint = 810;

    const surveyQuestions = [{
      text: "<span class='font-weight-500'>In the last 3 years</span>, have you had personal experience dealing with (paying for or being privy to) the cost of a funeral for someone you know? ",
      type: "QuizTwoOptionsSelect",
      options: ["Yes", "No"],
      btnClass: "surveyQuizBtn",
      textClass: "infoText",
      handler: this.handleFuneralExperience,
      value: "funeral_experience"
    },
    {
      text: "<div className='infoText font-weight-500'>Unfortunately, we are looking for information exclusively from those who have dealt with recent funeral costs.</div><div className='infoText mt-2'>We thank you for your willingness to take our survey.</div>",
      type: "SurveyDisqualified",
      textClass: "infoText"
    },
    {
      text: "Was the funeral a <span class='font-weight-500'>burial or cremation</span>?",
      type: "QuizTwoOptionsSelect",
      options: ["Burial", "Cremation"],
      btnClass: "surveyQuizBtn",
      textClass: "infoText",
      handler: this.handleFuneralType,
      value: "funeral_type"
    },
     {
      text: "In what <span class='font-weight-500'>state</span> was the funeral held?",
      type: "QuizStateSelect",
      validation: this.validateState,
      value: "funeral_state",
      textClass: "infoText"
    },
    {
      text: "To the best of your knowledge, what was the <span class='font-weight-500'>total cost</span> of the funeral?",
      type: "QuizCoverageInput",
      handler: this.handleFuneralCost,
      value: "funeral_cost",
      textClass: "infoText",
      bottomDescription: "Enter amount in numbers only. We understand that this may be an estimate.",
      onFocus: this.startFuneralCostTimer
    }, 
    {
      text: "Was there a <span class='font-weight-500'>funeral service</span> (memorial, viewing, etc.)?",
      type: "QuizTwoOptionsSelect",
      options: ["Yes", "No"],
      btnClass: "surveyQuizBtn",
      textClass: "infoText",
      handler: this.handleFuneralService,
      value: "funeral_service"
    },
     {
      text: "Did the total funeral cost <span class='font-weight-500'>seem higher, lower, or about what you expected</span>?",
      type: "QuizSelect",
      handler: this.handleFurneralPerceivedCost,
      value: "funeral_perceived_cost",
      textClass: "infoText",
      options: ["Higher", "Lower", "Expected"],
      btnClass: "surveyQuizBtn",
      layout: "pyramid"
    },
    {
      text: "<span class='font-weight-500'>Thank you for your participation!</span>",
      type: "QuizSurveyComplete",
      description: "Your contribution helps shed light on the true cost of a funeral. Through the input of real people with firsthand experience, we can continue to bring more accuracy and transparency to the final expense and funeral industries.",
      textClass: "fs-15 mb-2"
    }]

    this.state = {
      featured_quotes: [],
      quotes: [],
      mooQuoteGI: 0,
      modal: false,
      coverage: '10000',
      years: null,
      livingState: null,
      gender: null,
      smoked: null,
      stickyBanner: false,
      bannerWasDisplayed: false,
      windowWidth: window.innerWidth,
      productType: "final_expense",
      chatGptDerived: 'false',
      filteredQuotes: [],
      planModal: false,
      coverageTooltipKey: null,
      coverageTooltipContent: null,
      surveyQuestions: surveyQuestions,
      currentSurveyQuestion: surveyQuestions[0],
      currentSurveyQuestionI: 0,
      surveyModal: false,
      surveyComplete: false,
      shouldSeeSurvey: false,
      funeralCostError: false,
      funeralCostTimerFired: false,
      firstFuneralCostCheckDone: false
    };

  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  togglePlanModal = () => {
    this.setState({
      planModal: !this.state.planModal
    });
  };

  toggleSurveyModal = () => {
    let newState = { surveyModal: !this.state.surveyModal };

    // Using cross to close modal when seeing quiz complete messag should also close survey sticky bar
    if(this.state.currentSurveyQuestion.type == "QuizSurveyComplete")
      newState.surveyComplete = true;

    this.setState(newState);
  };

  closeSurveyComplete = () => {
    this.setState({
      surveyComplete: true,
      surveyModal: false
    })
  }

  goBack = () => {
    sessionStorage.setItem('goback', true);
    this.props.history.goBack();
  };


  componentDidMount() {
    if(this.props.states.length == 0) this.props.getStates();

    this._isMounted = true;
    this.props.updateProgressBar(true);
    document.querySelector('header').scrollIntoView();
    if (sessionStorage.getItem('generalInfo')) {
      this.setState({
        coverage: JSON.parse(sessionStorage.getItem('generalInfo')).coverage,
        years: JSON.parse(sessionStorage.getItem('generalInfo')).years,
        livingState: JSON.parse(sessionStorage.getItem('generalInfo'))
          .livingState,
        gender:  JSON.parse(sessionStorage.getItem('generalInfo')).gender,
        smoked:  JSON.parse(sessionStorage.getItem('generalInfo')).smoked,
      });
    }
    if (sessionStorage.getItem('quotes')) {
      this.setState({ quotes: JSON.parse(sessionStorage.getItem('quotes')) }, ()=> {
        this.setState({filteredQuotes: this.state.quotes.filter((q) => q.product_type === this.state.productType)})
      });
    }
    if (sessionStorage.getItem('featured_quotes')) {
      this.setState({
        featured_quotes: JSON.parse(sessionStorage.getItem('featured_quotes'))
      });
    }
    if (sessionStorage.getItem('highQuotesEnabled')) {
      this.setState({
        highQuotesEnabled: sessionStorage.getItem('highQuotesEnabled')
      });
    }
    if (sessionStorage.getItem('chatGptDerived')) {
      this.setState({
        chatGptDerived: sessionStorage.getItem('chatGptDerived')
      });
    }

    if(sessionStorage.getItem("should_see_survey") == "true") {
      this.setState({shouldSeeSurvey: true})
    }


    window.addEventListener('scroll', this.handleScroll);

    window.addEventListener('resize', this.bindStickyBanner, false);
    this.updateHeaderProgressBarVisibility();
  }

  componentWillUnmount() {
    if (this.props.toggleProgressBar)
      this.props.toggleProgressBar(true);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.bindStickyBanner, false);
    if (this.cancelToken) {
      this.cancelToken.cancel("Operation canceled as component unmounted.");
    }
  }

  handleScroll = () => {
    if(window.innerWidth < 810 ) {
      let scrollToDisplayBanner = 379;
      if (this.state.windowWidth >= 532)
        scrollToDisplayBanner = 352
      if (this.state.windowWidth >= 648)
        scrollToDisplayBanner = 263

      if(window.scrollY <= scrollToDisplayBanner)
        this.setState({stickyBanner: false});
      else {
        this.setState({stickyBanner: true});
        this.setState({bannerWasDisplayed: true});
      }
    }

    const now = Date.now();
  
    // Throttle: only send once every 2 seconds
    if (now - this.lastUpdateTimestamp < 2000) return; // 2 seconds
  
    const applicationId = sessionStorage.getItem('application_id');
    if (!applicationId) return;
  
    this.lastUpdateTimestamp = now;
    this.props.updateApplicationTimestamp(applicationId);
  }

  bindStickyBanner = () => {
    this.setState({ windowWidth : window.innerWidth })
    if(window.innerWidth >= 810) {
      if(this.state.stickyBanner)
        this.setState({stickyBanner: false});
      window.removeEventListener('scroll', this.handleScroll);
    } else {
      window.addEventListener('scroll', this.handleScroll);
    }
  }

  shouldHideHeaderProgressBar = ({ coverage, chatGptDerived, loading }) => {
    const normalizedCoverage = Number(String(coverage || '').replace(/[^\d]/g, ''));
    return chatGptDerived === 'true' && normalizedCoverage >= 50000 && !loading;
  }

  updateHeaderProgressBarVisibility = () => {
    if (!this.props.toggleProgressBar)
      return;
    const shouldHideProgressBar = this.shouldHideHeaderProgressBar({
      coverage: this.state.coverage,
      chatGptDerived: this.state.chatGptDerived,
      loading: this.props.loading
    });
    this.props.toggleProgressBar(!shouldHideProgressBar);
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.quotes !== this.props.quotes)
      this.setState({quotes: this.props.quotes, featured_quotes: this.props.featured_quotes, filteredQuotes: this.props.quotes.filter(q=> q.product_type === this.state.productType)});

    const previousShouldHideProgressBar = this.shouldHideHeaderProgressBar({
      coverage: prevState.coverage,
      chatGptDerived: prevState.chatGptDerived,
      loading: prevProps.loading
    });
    const currentShouldHideProgressBar = this.shouldHideHeaderProgressBar({
      coverage: this.state.coverage,
      chatGptDerived: this.state.chatGptDerived,
      loading: this.props.loading
    });
    if (previousShouldHideProgressBar !== currentShouldHideProgressBar)
      this.updateHeaderProgressBarVisibility();

    setTimeout(function(){
      var quoteList = document.querySelector('div.quotes');
      if(quoteList)
        quoteList.classList.remove('d-none');
    }, 50)
  }

  isMobile = () => {
    const md = new MobileDetect(window.navigator.userAgent);
    return md.mobile();
  };

  sortQuotesByPrice = e => {
    this.setState({ quotes: JSON.parse(sessionStorage.getItem('quotes')) });
    this.toggleBolder(e.target);
  };

  sortQuotesByRating = e => {
    const RAPP = [];
    const RAP = [];
    const RA = [];
    const RAM = [];
    const RBPP = [];
    const RBP = [];
    const RB = [];
    const RBM = [];
    const RCPP = [];
    const RCM = [];
    const RD = [];
    const RE = [];
    const RF = [];
    const RS = [];

    this.state.quotes.forEach(quote => {
      if (quote.rating === 'A++') {
        RAPP.push(quote);
      }
      if (quote.rating === 'A+') {
        RAP.push(quote);
      }
      if (quote.rating === 'A') {
        RA.push(quote);
      }
      if (quote.rating === 'A-') {
        RAM.push(quote);
      }
      if (quote.rating === 'B++') {
        RBPP.push(quote);
      }
      if (quote.rating === 'B+') {
        RBP.push(quote);
      }
      if (quote.rating === 'B') {
        RB.push(quote);
      }
      if (quote.rating === 'B-') {
        RBM.push(quote);
      }
      if (quote.rating === 'C++') {
        RCPP.push(quote);
      }
      if (quote.rating === 'C-') {
        RCM.push(quote);
      }
      if (quote.rating === 'D') {
        RD.push(quote);
      }
      if (quote.rating === 'E') {
        RE.push(quote);
      }
      if (quote.rating === 'F') {
        RF.push(quote);
      }
      if (quote.rating === 'S') {
        RS.push(quote);
      }
    });

    this.setState({
      quotes: [
        ...RAPP,
        ...RAP,
        ...RA,
        ...RAM,
        ...RBPP,
        ...RBP,
        ...RB,
        ...RBM,
        ...RCPP,
        ...RCM,
        ...RD,
        ...RE,
        ...RF,
        ...RS
      ]
    });
    this.toggleBolder(e.target);
  };

  toggleBolder = target => {
    document.querySelector('.sort-bolder').classList.remove('sort-bolder');
    target.classList.add('sort-bolder');
  };

updateCoverage = (e, noTimeout = false) => {
  if(e && e.value) {
    this.setState({ coverage: e.value }, ()=> {
      if(noTimeout)
        this.updatePrices(e.value);
      else
        setTimeout(() => {
          this.updatePrices(e.value);
        }, 200);
    });
  }
}

updatePrices = async (coverage) => {
    if (coverage === this.state.coverage) {
      // Access the instance variable directly
      if (this.cancelToken) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }

      // Initialize the instance variable directly
      this.cancelToken = axios.CancelToken.source();

      const generalInfo = JSON.parse(sessionStorage.getItem('generalInfo'));
      generalInfo.coverage = this.state.coverage;
      generalInfo.path = '/quotes-list';
      sessionStorage.setItem('generalInfo', JSON.stringify(generalInfo));

      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + 'quotes',
          {
            general_info: generalInfo,
            requote: true,
            application_id: sessionStorage.getItem('application_id'),
          },
          { cancelToken: this.cancelToken.token }
        );

        const featured_quotes = [
          ...response.data.featured_immediate_coverage_plan,
          ...response.data.featured_guaranteed_issue_plan,
        ];

        sessionStorage.setItem(
          'featured_quotes',
          JSON.stringify(featured_quotes)
        );
        sessionStorage.setItem('quotes', JSON.stringify(response.data.quotes));
        sessionStorage.setItem('application_id', response.data.application_id);

        this.setState({
          quotes: response.data.quotes,
          featured_quotes,
          filteredQuotes: response.data.quotes.filter(
            (q) => q.product_type === this.state.productType
          ),
        });
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled:', error.message);
        } else {
          console.error('Error:', error);
        }
      }
    }
  };

  setCoverageToShow(x) {
    // Special handling for $2,000,000+ option (using 2500000 as the value)
    if (x === 2500000 || x === "2500000") {
      return "2,000,000+";
    }
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  saveQuote = quote => {
    sessionStorage.setItem('quote', JSON.stringify(quote));
    sessionStorage.setItem('mooQuoteGI', this.state.mooQuoteGI);
    sessionStorage.setItem('productType', this.state.productType);
    this.props.updateApplicationState(
      sessionStorage.getItem('application_id'), 
      'quote_selected', 
      quote.name,
      quote.insurance_amount
    );
    this.props.history.push('/application');
  };

  toggleProductType = productType => {
    this.setState({ productType, filteredQuotes: this.state.quotes.filter(q=> q.product_type === productType) }, ()=> {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    })
  };

  setCoverageTooltip = (key, content) => {
    this.setState({ coverageTooltipKey: key, coverageTooltipContent: content })
  };

  handleFuneralExperience = val => {
    this.handleTwoOptionsSelect(val, ["Yes", "No"], "funeral_experience")
  };

  animateTransition = (nextQuestionI, currentQuestionI) => {
    const container = document.querySelector(".surveyModal");

    if(nextQuestionI > currentQuestionI) {
      container.getElementsByClassName(`question${currentQuestionI}`)[0].classList.add("slideLeft");
      container.getElementsByClassName(`question${nextQuestionI}`)[0].classList.remove("slideLeft");
    }
    else {
      container.getElementsByClassName(`question${currentQuestionI}`)[0].classList.add("slideRight");
      container.getElementsByClassName(`question${nextQuestionI}`)[0].classList.remove("slideRight");
    }

  } 

  previousQuestion = () => {
    let previousQuestionIndex = this.state.currentSurveyQuestionI == 2 ? this.state.currentSurveyQuestionI - 2 : this.state.currentSurveyQuestionI - 1;

    const newCurrentQuestion = this.state.surveyQuestions[previousQuestionIndex];
    this.animateTransition(previousQuestionIndex, this.state.currentSurveyQuestionI)
    this.setState(
      { 
        currentSurveyQuestion: newCurrentQuestion,
        currentSurveyQuestionI: previousQuestionIndex,
        // When going back to two options questions we show continue button
        enableContinueForTwoOptions: newCurrentQuestion.value == "funeral_experience" || newCurrentQuestion.value == "funeral_type",
        prevQuestionI: this.state.currentSurveyQuestionI
      });
  };

  nextQuestion = () => {
    if(this.state.isNavigationDisabled || !this.currentValueFullfilled() || (this.state.currentSurveyQuestion['validation'] && !this.state.currentSurveyQuestion["validation"]))
      return;
    this.setState({isNavigationDisabled: true})
    this.animateTransition(this.state.currentSurveyQuestionI+1, this.state.currentSurveyQuestionI)
    
    let nextQuestionIndex = this.state.currentSurveyQuestionI + 1;
    if(this.state.currentSurveyQuestionI == 0 && this.state.funeral_experience == "yes") {
      nextQuestionIndex = this.state.currentSurveyQuestionI + 2;
    }

    const newCurrentSurveyQuestion = this.state.surveyQuestions[nextQuestionIndex];

    if(newCurrentSurveyQuestion.type == "SurveyDisqualified") {
      this.props.saveSurveyResponse(sessionStorage.getItem('application_id'), {
        funeral_survey: {
          funeral_experience: false,
        }
      });
    }

    if(newCurrentSurveyQuestion.type == "QuizSurveyComplete") {
      const applicationId = sessionStorage.getItem('application_id');
      if (applicationId) 
        this.props.saveSurveyResponse(applicationId, {
          funeral_survey: {
            funeral_experience: true,
            funeral_type: this.state.funeral_type,
            funeral_state: this.state.funeral_state,
            funeral_cost: this.state.funeral_cost,
            funeral_perceived_cost: this.state.funeral_perceived_cost,
            funeral_service: this.state.funeral_service == "yes" ? true : false
          }
        });
    }

    setTimeout(()=> {
      if (this._isMounted) 
        this.setState(
          { 
            currentSurveyQuestion: newCurrentSurveyQuestion,
            currentSurveyQuestionI: nextQuestionIndex,
            enableContinueForTwoOptions: this.showContinueHandler(newCurrentSurveyQuestion),
            prevQuestionI: this.state.currentSurveyQuestionI
          }, ()=> {
            this.setState({isNavigationDisabled: false})
          });
      }, 500)

  };

  showContinueHandler = (newCurrentQuestion) => {
    let enableContinueForTwoOptions = false;
    // For two options we show continue if the value is populated when showing them
    if((newCurrentQuestion.value == "funeral_experience" && this.state.funeral_experience) || (newCurrentQuestion.value == "funeral_type" && this.state.funeral_type))
      enableContinueForTwoOptions = true;

    return enableContinueForTwoOptions;
  }

  currentValueFullfilled = () => {
    const { currentSurveyQuestion } = this.state;
    const field = currentSurveyQuestion && currentSurveyQuestion.value;

    if (!field) return false;

    // Special rule for funeral cost: must be >= 100 and no error
    if (field === 'funeral_cost') {
      return this.isFuneralCostValid();
    }

    // Default behavior for other questions
    return !!this.state[field];
  };


  validateState = () => {
    this.setState({error_state: ''})
    if(this.state.funeral_state)
      return true;

    this.setState({error_state: 'Please select the state.'})
    return false;
  };

  handleState = (e) => {
   this.setState({ funeral_state: e.value });
  };

  handleFuneralType = val => {
    this.handleTwoOptionsSelect(val, ["Burial", "Cremation"], "funeral_type")
  };

  handleTwoOptionsSelect = (val, options, name) => {
    // Mark the option before the animation happens
    const valToUnmark = val == options[0] ? options[1] : options[0];
    const valToMark = val == options[1] ? options[1] : options[0];
    const container = document.querySelector(`.surveyModal .question${this.state.currentSurveyQuestionI}`);

    container.querySelector(`#quizButton_surveyQuizBtn_${valToUnmark}`).classList.remove("selected");
    container.querySelector(`#selectedImg_surveyQuizBtn_${valToUnmark}`).classList.remove("d-block");
    container.querySelector(`#quizButton_surveyQuizBtn_${valToMark}`).classList.add("selected");
    container.querySelector(`#selectedImg_surveyQuizBtn_${valToMark}`).classList.add("d-block");

    $(`.continueQ.questionI${this.state.currentSurveyQuestionI}`).removeClass("disabled");
    $(`.continueQ.questionI${this.state.currentSurveyQuestionI}`).addClass("enabled");


    this.setState({ [name]: val.toLowerCase(),});
  }

  handleFuneralCost = (value) => {
    const numeric = parseInt(value || "0", 10);

    this.setState(
      { funeral_cost: value },
      () => {
        // After first timed check → immediate behavior only
        if (this.state.firstFuneralCostCheckDone) {
          this.updateFuneralCostError();
          return;
        }

        // Before first timed check → no extra timer logic needed here
        this.updateFuneralCostError();
      }
    );
  };



  startFuneralCostTimer = () => {
    // Do NOT start timer again after first check
    if (this.state.firstFuneralCostCheckDone) return;
  
    if (this.funeralCostTimer) clearTimeout(this.funeralCostTimer);
  
    this.funeralCostTimer = setTimeout(() => {
      this.setState(
        { 
          funeralCostTimerFired: true,
          firstFuneralCostCheckDone: true
        },
        this.updateFuneralCostError
      );
    }, 2000);
  };



  updateFuneralCostError = () => {
    const numeric = parseInt(this.state.funeral_cost || "0", 10);
  
    // Always remove error instantly when valid
    if (!isNaN(numeric) && numeric >= 100) {
      this.setState({
        funeralCostError: false,
        funeralCostTimerFired: false
      });
      return;
    }
  
    // First time = only show after timer
    // Later times = show instantly
    const shouldShowError =
      this.state.firstFuneralCostCheckDone
        ? (isNaN(numeric) || numeric < 100)
        : (this.state.funeralCostTimerFired &&
           (isNaN(numeric) || numeric < 100));
        
    this.setState({ funeralCostError: shouldShowError });
  };

  
  isFuneralCostValid = () => {
    const numeric = parseInt(this.state.funeral_cost || "0", 10);
    return (
      !this.state.funeralCostError &&
      !isNaN(numeric) &&
      numeric >= 100
    );
  };

  handleFuneralService = (val) => {
    this.handleTwoOptionsSelect(val, ["Yes", "No"], "funeral_service")
  }

  handleFurneralPerceivedCost = (val) => {
    let options = this.state.currentSurveyQuestion.options;
    const container = document.querySelector(".surveyModal");

    // Mark the option before the animation happens
    const valToUnmark = options.filter(item => !val.includes(item));
    const valToMark = val;

    valToUnmark.forEach(unchecked => {
      container.querySelector(`#quizButton_surveyQuizBtn_${unchecked}`).classList.remove("selected");
      container.querySelector(`#selectedImg_surveyQuizBtn_${unchecked}`).classList.remove("d-block");
    })

    container.querySelector(`#quizButton_surveyQuizBtn_${valToMark}`).classList.add("selected");
    container.querySelector(`#selectedImg_surveyQuizBtn_${valToMark}`).classList.add("d-block");

    $(`.continueQ.questionI${this.state.currentSurveyQuestionI}`).removeClass("disabled");
    $(`.continueQ.questionI${this.state.currentSurveyQuestionI}`).addClass("enabled");

    this.setState({ funeral_perceived_cost: val.toLowerCase()});
  };


  render() {

    return (
      <section className="sector position-static col-xs-12 quotesBackground" >
        {this.props.loading && <Loader />}
        
        {(this.isMobile() && this.props.loading) ||
        this.state.quotes.length == 0 ||
        (this.state.coverage >= 50000 && !this.props.loading) ? (
          ''
         ) : (
         <FixedButton text="Edit Information" handleClick={this.goBack} sticky={this.state.stickyBanner} class={"editInformationContainer"} />
         )
        }


        {this.state.quotes.length > 0 && this.state.coverage < 50000 && !this.props.loading ? (
          <QuotesLayout
            featured_quotes={this.state.featured_quotes}
            quotes={this.state.quotes}
            competitor_quotes={this.state.competitor_quotes}
            modal={this.state.modal}
            planModal={this.state.planModal} 
            coverage={this.state.coverage}
            years={this.state.years}
            livingState={this.state.livingState}
            smoked={this.state.smoked}
            gender={this.state.gender}
            stickyBanner={this.state.stickyBanner}
            bannerWasDisplayed={this.state.bannerWasDisplayed}
            highQuotesEnabled={this.state.highQuotesEnabled}
            filteredQuotes={this.state.filteredQuotes}
            productType={this.state.productType}
            coverageTooltipKey={this.state.coverageTooltipKey}
            coverageTooltipContent={this.state.coverageTooltipContent}
            surveyQuestions={this.state.surveyQuestions}
            currentSurveyQuestion={this.state.currentSurveyQuestion}
            currentSurveyQuestionI={this.state.currentSurveyQuestionI}
            prevQuestionI={this.state.prevQuestionI}
            surveyModal={this.state.surveyModal}
            funeral_experience={this.state.funeral_experience}
            funeral_type={this.state.funeral_type}
            enableContinueForTwoOptions={this.state.enableContinueForTwoOptions}
            states={this.props.states}
            surveyComplete={this.state.surveyComplete}
            shouldSeeSurvey={this.state.shouldSeeSurvey}
            funeralCostError={this.state.funeralCostError}
            toggle={this.toggle}
            togglePlanModal={this.togglePlanModal}
            toggleSurveyModal={this.toggleSurveyModal}
            updateCoverage={this.updateCoverage}
            updatePrices={this.updatePrices}
            saveQuote={this.saveQuote}
            sortQuotesByRating={this.sortQuotesByRating}
            sortQuotesByPrice={this.sortQuotesByPrice}
            setCoverageToShow={this.setCoverageToShow}
            isMobile={this.isMobile}
            toggleProductType={this.toggleProductType}
            setCoverageTooltip={this.setCoverageTooltip}
            previousQuestion={this.previousQuestion}
            nextQuestion={this.nextQuestion}
            currentValueFullfilled={this.currentValueFullfilled}
            handleOption={this.handleState}
            closeSurveyComplete={this.closeSurveyComplete}
          />
        ) : (this.state.coverage >= 50000) ? 
        !this.props.loading && (
          < DeepQuoteExploration
            coverage={this.setCoverageToShow(this.state.coverage)}
            goBack={this.goBack}
            chatGptDerived={this.state.chatGptDerived}
          />
        ):
        !this.props.loading && (
          < NoQuotesLayout highQuotesEnabled={this.state.highQuotesEnabled} />
        )}
      </section>
    );
  }
}

const mapStateToProps  = (state) => ({
  quotes: state.consumer.quotes,
  featured_quotes: state.consumer.featured_quotes,
  loading: state.consumer.loading,
  states: state.agents.states
})

export default compose(
  connect(mapStateToProps, 
    {getQuotes, setLoading, updateProgressBar, updateApplicationState, updateApplicationTimestamp, getStates, saveSurveyResponse}), 
  withRouter,
  withMobileDetect)(Quotes);